import './carouselComponent.styles.scss'
import { useEffect, useCallback, useState, ReactNode } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import { EmblaCarouselType } from 'embla-carousel'

const wheelGestures = WheelGesturesPlugin({
  forceWheelAxis: 'x',
  wheelDraggingClass: 'is-wheel-dragging',
})

interface CarouselPropsInterface {
  children: ReactNode
  className?: string
  leftIcon?: ReactNode
  rightIcon?: ReactNode
}

export const CarouselComponent = ({
  children,
  className = '',
  leftIcon,
  rightIcon,
}: CarouselPropsInterface) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({ dragFree: true }, [
    wheelGestures,
  ])
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
  }, [emblaApi])

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect).on('select', onSelect)
  }, [emblaApi, onSelect])

  return (
    <div className={`embla ${className}`}>
      {/* Left Button */}
      {leftIcon && (
        <button
          className='embla__prev'
          onClick={onPrevButtonClick}
          disabled={prevBtnDisabled}
        >
          {leftIcon}
        </button>
      )}
      {/* Carousel */}
      <div className={'embla__viewport'} ref={emblaRef}>
        <div className='embla__container'>{children}</div>
      </div>

      {/* Right Button */}
      {rightIcon && (
        <button
          className='embla__next'
          onClick={onNextButtonClick}
          disabled={nextBtnDisabled}
        >
          {rightIcon}
        </button>
      )}
    </div>
  )
}
